var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaterialAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-add-circle",
    "data-name": "Icon material-add-circle",
    d: "M13,3A10,10,0,1,0,23,13,10,10,0,0,0,13,3Zm5,11H14v4H12V14H8V12h4V8h2v4h4Z",
    transform: "translate(-3 -3)",
    fill: "#446fa2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterialAddCircle);
export default __webpack_public_path__ + "static/media/icon-material-add-circle.c2c28f308895fa6203c6bae75aaa42d8.svg";
export { ForwardRef as ReactComponent };